import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const LogoLoganMenuSvg = () => (
  <svg width="109" height="32" viewBox="0 0 109 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5538 23.3712C22.0538 23.3712 21.5735 23.4521 21.1249 23.5932L21.1269 23.5913C20.2731 23.834 19.6842 24.3062 18.5616 23.644L9.81638 17.8162C8.88554
      17.0807 9.10096 16.4186 9.06538 15.6191C9.07922 14.7575 8.80253 14.0615 9.98635 13.2225H9.98239L16.7552 8.4162C17.7849 7.80671 18.3778 8.21492 19.1901
      8.43313C19.198 8.43501 19.2059 8.43689 19.2138 8.43877C19.2237 8.44066 19.2316 8.44442 19.2415 8.4463V8.44442C19.6545 8.56293 20.0913 8.62689 20.5458
      8.62689C23.0498 8.62689 25.0775 6.69496 25.0775 4.31344C25.0775 1.93193 23.0478 0 20.5438 0C18.0399 0 16.0121 1.93193 16.0121 4.31344C15.9845 5.20322
      16.3027 5.91053 15.0912 6.77209L8.30647 11.5878C7.28669 12.1841 6.69577 11.7778 5.88746 11.5615C5.87955 11.5596 5.87165 11.5577 5.86374 11.5539C5.85584
      11.5521 5.84596 11.5483 5.83805 11.5464C5.425 11.4279 4.98626 11.3621 4.53368 11.3621C2.02968 11.3639 0 13.2959 0 15.6774C0 18.0608 2.02968 19.9908 4.5317
      19.9908C5.02974 19.9908 5.50801 19.9118 5.95663 19.7707L5.95465 19.7726C6.84795 19.5205 7.45073 19.0145 8.67605 19.8215L17.1742 25.4837C18.2335 26.2663
      17.9667 26.9586 18.0201 27.8088L18.024 27.8051C18.0912 30.132 20.0893 31.9981 22.5498 31.9981C25.0538 31.9981 27.0815 30.0662 27.0815 27.6847C27.0815
      25.3032 25.0578 23.3712 22.5538 23.3712Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M20.5141 8.62877C21.0141 8.62877 21.4944 8.54788 21.943 8.4068L21.941 8.40868C22.7948 8.16601 23.3837 7.69384 24.5063 8.356L33.2515 14.1838C34.1824
      14.9193 33.9669 15.5814 34.0025 16.3809C33.9887 17.2425 34.2654 17.9385 33.0815 18.7775H33.0855L26.3126 23.5838C25.283 24.1933 24.6901 23.7851 23.8778
      23.5669C23.8699 23.565 23.862 23.5631 23.8541 23.5612C23.8442 23.5593 23.8363 23.5556 23.8264 23.5537V23.5556C23.4134 23.4371 22.9766 23.3731 22.5221
      23.3731C20.0181 23.3731 17.9904 25.305 17.9904 27.6866C17.9904 30.0681 20.02 32 22.5221 32C25.0261 32 27.0538 30.0681 27.0538 27.6866C27.0814 26.7968
      26.7632 26.0895 27.9747 25.2279L34.7594 20.4122C35.7792 19.8159 36.3701 20.2222 37.1785 20.4385C37.1864 20.4404 37.1943 20.4423 37.2022 20.4461C37.2101
      20.4479 37.22 20.4517 37.2279 20.4536C37.6409 20.5721 38.0797 20.6379 38.5322 20.6379C41.0362 20.6379 43.0639 18.706 43.0639 16.3245C43.0639 13.9411 41.0343
      12.0111 38.5322 12.0111C38.0342 12.0111 37.5559 12.0901 37.1073 12.2311L37.1093 12.2293C36.216 12.4813 35.6132 12.9874 34.3879 12.1804L25.8897 6.51814C24.8304
      5.73558 25.0972 5.04332 25.0438 4.19305L25.0399 4.19681C24.9727 1.86797 22.9746 0 20.5141 0C18.0121 0 15.9824 1.93193 15.9824 4.31344C15.9824 6.69496 18.0121
      8.62877 20.5141 8.62877Z"
      fill="url(#paint1_linear)"
    />
    <path d="M51.3586 21.4544V19.0108V6.5614H53.9259V19.0108H62.092V21.4544H53.9259H51.3586Z" fill="black" />
    <path
      d="M73.7861 15.999C73.7861 17.899 72.7742 19.5656 71.2188 20.5401C70.3235 21.1195 69.2346 21.4524 68.0824 21.4524C64.9064 21.4524 62.353 19.0088 62.353
      15.999C62.353 13.0005 64.9064 10.5569 68.0824 10.5569C69.2366 10.5569 70.3255 10.8898 71.2188 11.4579C72.7762 12.4343 73.7861 14.1122 73.7861 15.999ZM68.0824
      19.0107C69.8057 19.0107 71.2188 17.6657 71.2188 16.0009C71.2188 14.3474 69.8057 13.0024 68.0824 13.0024C66.3333 13.0024 64.9203 14.3474 64.9203 16.0009C64.9203
      17.6657 66.3333 19.0107 68.0824 19.0107Z"
      fill="black"
    />
    <path
      d="M80.0369 21.4544C78.9223 21.4299 77.859 21.097 77.0033 20.542C75.4479 19.5676 74.436 17.9009 74.436 16.001C74.436 14.1123 75.4479 12.4343 77.0033
      11.4599C77.8985 10.8918 78.9875 10.5588 80.1535 10.5588C81.3077 10.5588 82.3966 10.8918 83.3038 11.4599V10.5588H85.871V16.001C85.871 17.9009 84.8473
      19.5676 83.3038 20.542C83.1101 20.6662 82.9144 20.7772 82.7069 20.875L83.0963 21.4544L84.1714 22.9969L85.869 25.4405H82.7959H75.9894V22.9969H81.1101L80.0369
      21.4544ZM80.1535 13.0024C78.4025 13.0024 77.0033 14.3474 77.0033 16.001C77.0033 16.9396 77.4302 17.7655 78.1436 18.3091C78.6871 18.7418 79.3749 19.0127 80.1535
      19.0127C80.5429 19.0127 80.9322 18.9393 81.282 18.8151C82.4619 18.3825 83.3038 17.2858 83.3038 16.001C83.3038 14.3474 81.8907 13.0024 80.1535 13.0024Z"
      fill="black"
    />
    <path
      d="M86.5193 15.999C86.5193 14.1104 87.543 12.4324 89.0865 11.4579C89.9937 10.8898 91.0826 10.5569 92.2506 10.5569C93.4166 10.5569 94.4937 10.8898 95.4009
      11.4579V10.5569H97.9681V15.999V21.4524H95.4009V20.5401C94.4937 21.1195 93.4186 21.4524 92.2506 21.4524C91.0846 21.4524 89.9956 21.1195 89.0865 20.5401C87.545
      19.5656 86.5193 17.9008 86.5193 15.999ZM95.4009 15.999C95.4009 14.3455 93.9878 13.0005 92.2506 13.0005C90.4996 13.0005 89.0865 14.3455 89.0865 15.999C89.0865 17.6657
      90.4996 19.0088 92.2506 19.0088C93.9878 19.0107 95.4009 17.6657 95.4009 15.999Z"
      fill="black"
    />
    <path
      d="M106.433 15.4949C106.433 14.1255 105.241 13.0024 103.8 13.0024C102.373 13.0024 101.182 14.1255 101.182
      15.4949V19.0108V21.4544H98.6145V15.4949V10.5588H101.182V11.2492C101.96 10.8053 102.842 10.5588 103.8 10.5588C104.759 10.5588 105.654 10.8053 106.433
      11.2492C107.963 12.1014 109 13.6928 109 15.4931V21.4525H106.433V19.0089V15.4949Z"
      fill="black"
    />
    <defs>
      <linearGradient id="paint0_linear" x1="0" y1="17.499" x2="28.7527" y2="17.499" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4ECAF0" />
        <stop offset="1" stopColor="#0891B3" />
      </linearGradient>
      <linearGradient id="paint1_linear" x1="16.9688" y1="17.5" x2="45.7215" y2="17.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4ECAF0" />
        <stop offset="1" stopColor="#0891B3" />
      </linearGradient>
    </defs>
  </svg>
);

const LogoLoganMenu = (props: IIconProps) => <Icon component={LogoLoganMenuSvg} {...props} />;

export default LogoLoganMenu;
